import axios from "axios";
import config from "../../config";


export default {
    namespaced: true,
    //state เป็นข้อมุลที่ถูกจัดเก็บใน store
    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    // action เป็นส่วน action ต่างๆ เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    // commit เราจะใช้ในการเรียก Mutation ขึ้นมาทํางานโดยจะระบุเป็นชื่อของ Mutation และสามารถส่งข้อมูลไปด้วยได้ (Mutation จะได้รับข้อมูลเข้ามาผ่านทาง payload)
    // payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Action นี้ขึ้นมาทํางาน || payload คือ ข้อมูลที่รับเข้ามา เมื่อเราเรียก Mutaion นี้ขึ้นมาทํางาน
    // action---[commit]---> mutations---> state
    // dispatch

    // state >> store สำหรับจัดเก็บข้อมูลตรงกลาง
    state: {
        webConPersons: [],
        images: [],
        isReceiving: false, // กำลังบันทึก
        isUpdating: false, //กำลังอัพเดท
        isDeleting: false,  //กำลังลบ
        idToDelete: null, // id-pk สำหรับ ลบ
        webConPersonMessage: '', // ข้อความ
        errorMessage: false
    },
    // actions เช่นบันทึก ดึง ข้อมูลแล้ว commit ไปยัง ---> mutations
    actions: {

        getWebConPersonsRequest({dispatch}) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConPersons", null);
            } else {
                dispatch("receivingWebConPersons"); // สถานะ กำลังบันทึก

                axios.get('/webConPersons').then(res => {

                    dispatch("receiveWebConPersons", res.data);
                })
                    .catch((e) => {
                        console.log(e);
                        dispatch("receiveWebConPersons", null);
                    })
            }
        },
        loadWebConPersonRequest({dispatch}, id) {
            // We check if app runs with backend mode
            if (!config.isBackend) {
                dispatch("receiveWebConPerson", null.find(arr => arr.id === id));
            } else {
                dispatch("receivingWebConPerson");
                axios.get('/webConPersons/' + id).then(res => {
                    dispatch("receiveWebConPerson", res.data);
                })
            }
        },
        updateWebConPersonRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("updatingWebConPerson");
            axios.put('/webConPersons/' + payload.persons_id, payload).then(res => {
                dispatch("updateWebConPerson", res.data);
            })
        },
        createWebConPersonRequest({dispatch}, payload) {
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("receivingWebConPerson");
            axios.post('/webConPersons', payload).then(res => {
                dispatch("receiveWebConPerson", res.data);
            })
        },
        deleteWebConPersonRequest({dispatch}, payload) {

            dispatch("afterDeleteWebConPerson", payload);
            // We check if app runs with backend mode
            if (!config.isBackend) return;

            dispatch("deletingWebConPerson", payload);

            axios.post('/delete_webConPersons', payload).then(res => {
                dispatch("deleteWebConPerson", {persons_id: payload.persons_id, res: res});
            })


        },
        receiveWebConPersons({commit}, payload) {
            commit("RECEIVED_PERSONS", payload)
        },
        receivingWebConPersons({commit}) {
            commit("RECEIVING_PERSONS") //call matutions --> state.isReceiving = true;
        },
        receiveWebConPerson({commit}, payload) {
            commit("RECEIVED_PERSON", payload)
        },
        receivingWebConPerson({commit}) {
            commit("RECEIVING_PERSONS") //call matutions --> state.isReceiving = true;
        },
        updateWebConPerson({commit}, payload) {
            commit("UPDATED_PERSON", payload)
        },
        updatingWebConPerson({commit}) {
            commit("UPDATING_PERSON") //  call matutions --> state.isUpdating = true;
        },
        deleteWebConPerson({commit}, payload) {
            commit("DELETED_PERSON", payload)
        },
        deletingWebConPerson({commit}, payload) {
            commit("DELETING_PERSON", payload)
        },
        afterDeleteWebConPerson({commit}, payload) {
            commit("AFFTER_DELETED_PERSON", payload)
        }

    },
    // mutations เป็นส่วนในการเปลี่ยนแปลงข้อมูลของ state ใน store ที่ได้รับการ commit จาก action
    mutations: {
        //

        RECEIVED_PERSONS(state, payload) {
            state.webConPersons = payload;
            state.isReceiving = false;

        },
        RECEIVING_PERSONS(state) {
            state.isReceiving = true;
            state.errorMessage = true;
        },

        RECEIVED_PERSON(state, payload) {


            if (payload.persons_id == undefined) {
                let error = !payload.e.errorInfo==true?payload.message:payload.e.errorInfo.toString()
                let webConPersonMessage = 'พบข้อผิดพลาด :' + error;
                state = Object.assign(state, {
                    isReceiving: false,
                    webConPersonMessage: (state.webConPersonMessage == webConPersonMessage ? webConPersonMessage + ' ' : webConPersonMessage),

                });
            } else {
                let webConPersonMessage = 'บันทึกสำเร็จ! รายการ ' + payload.persons_id + ' ถูกบันทึกแล้ว';
                state = Object.assign(state, {
                    webConPersons: [...state.webConPersons, payload],
                    isReceiving: false,
                    errorMessage: false,
                    webConPersonMessage: (state.webConPersonMessage == webConPersonMessage ? webConPersonMessage + ' ' : webConPersonMessage),
                })
            }


            //**เช็คกรณีไม่สำเร็จ
        },
        // RECEIVING_PERSON(state) {
        //     state.isReceiving = true;
        // },

        UPDATED_PERSON(state, payload) {
            let index = state.webConPersons.findIndex(p => p.persons_id === payload.persons_id);
            let webConPersonMessage = 'บันทึกสำเร็จ! รายการ ' + payload.persons_id + ' ถูกแก้ไขแล้ว';
            state = Object.assign(state, {
                webConPersons: state.webConPersons.map((p, i) => {
                    if (i === index) {
                        return Object.assign({}, p, payload);
                    }
                    return p;
                }),
                isUpdating: false,
                webConPersonMessage: (state.webConPersonMessage == webConPersonMessage ? webConPersonMessage + ' ' : webConPersonMessage),
            })
        },
        UPDATING_PERSON(state) {
            state.isUpdating = true;
            state.errorMessage = false;
        },

        DELETED_PERSON(state, payload) {

console.log('delete')
            if (payload.persons_id == undefined || payload.res.data.message == 'Relation') {
                let webConPersonMessage = 'ไม่สามารถลบรายการได้ มีบางรายการอ้างอิงอยู่! รายการ ' + payload.res.data.persons_id;
                state = Object.assign(state, {
                    isDeleting: false,
                    idToDelete: null,
                    webConPersonMessage: (state.webConPersonMessage == webConPersonMessage ? webConPersonMessage + ' ' : webConPersonMessage),

                });
            } else {
                let indexToDelete = state.webConPersons.findIndex(p => p.persons_id === payload.persons_id);
                let webConPersons = [...state.webConPersons];
                webConPersons.splice(indexToDelete, 1);
                let webConPersonMessage = 'บันทึกสำเร็จ! รายการ ' + payload.persons_id + ' ถูกลบแล้ว';
                state = Object.assign(state, {
                    webConPersons: [...webConPersons],
                    isDeleting: false,
                    idToDelete: null,
                    webConPersonMessage: (state.webConPersonMessage == webConPersonMessage ? webConPersonMessage + ' ' : webConPersonMessage),
                    errorMessage: false
                });
            }


        },
        DELETING_PERSON(state, payload) {
            state.isDeleting = true;
            state.errorMessage = true;
            state.idToDelete = payload.persons_id;
        },
        AFFTER_DELETED_PERSON(state) {
            state.errorMessage = false;

        },
    },

    // getters จะใช้ในกรณีต้องการ process อะไรบางอย่างก่อนที่จะนำข้อมูลใน store ไปใช้
    getters: {}

};
